import { render, staticRenderFns } from "./AttachmentListItem.vue?vue&type=template&id=b93e796e&scoped=true&"
import script from "./AttachmentListItem.vue?vue&type=script&lang=ts&"
export * from "./AttachmentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentListItem.vue?vue&type=style&index=0&id=b93e796e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93e796e",
  null
  
)

export default component.exports